import type { DiffResult, ServiceState } from "@rebuild/shared";
import RestAPI from "../../utils/restAPI";

export async function fetchDeployState(): Promise<ServiceState[]> {
	const data = await RestAPI.fetchRebuildAPI("/rest/deploy/state", "GET", {}, "data", true, true);
	return data?.states ?? [];
}

export async function fetchDiff(base: string, head: string): Promise<DiffResult> {
	const data = await RestAPI.fetchRebuildAPI("/rest/deploy/diff", "GET", { base, head }, "data", true, true);
	return data ?? { pulls: [], commits: 0, ahead: 0 };
}

export async function authenticateDeploy(password: string): Promise<boolean> {
	const result = await RestAPI.fetchRebuildAPI("/rest/deploy/auth", "POST", { password }, "success", false, false);
	return result === true;
}

export async function promoteService(params: {
	service: string;
	deploymentId?: string;
	imageRef?: string;
}): Promise<void> {
	const result = await RestAPI.fetchRebuildAPI("/rest/deploy/promote", "POST", params, "data", true, false);
	if (!result) throw new Error("Promotion failed");
}
